import React, { useState, useEffect } from 'react'; // Import useEffect
import './ToggleButton.css';

function ToggleButton({ checked, onChange }) {
    const [on, setOnState] = useState(checked);

    // Add useEffect to sync internal state with the 'checked' prop
    useEffect(() => {
        setOnState(checked);
    }, [checked]); // Re-run this effect whenever the 'checked' prop changes

    const toggle = () => {
        const newState = !on;
        setOnState(newState);
        onChange(newState);
    };

    return (
        <div className='togglebutton center'>
            {/* Keep your original text logic for now, assuming the issue is initial sync */}
            <div onClick={toggle} className={on ? 'Ja' : 'Nej'}>
                {on ? 'Ja' : 'Nej'}
            </div>
        </div>
    );
}

export default ToggleButton;


